import CryptoJS from 'crypto-js';
import { cardIndex } from './words';

const encryptKey = 'btsHeardleSecret'
const gameStateKey = 'gameState'

type StoredGameState = {
  guesses: string[]
  solution: string
}

export const saveGameStateToLocalStorage = (gameState: StoredGameState) => {
  localStorage.setItem(gameStateKey, JSON.stringify(gameState))
}

export const loadGameStateFromLocalStorage = () => {
  const state = localStorage.getItem(gameStateKey)
  return state ? (JSON.parse(state) as StoredGameState) : null
}

const gameStatKey = 'gameStats'
const winningCardKey = 'winningCards'
const cardsSequenceKey = 'cardsSequence'

export type GameStats = {
  winDistribution: number[]
  gamesFailed: number
  currentStreak: number
  bestStreak: number
  totalGames: number
  successRate: number
}

export type WinningCard = {
  id: number,
  albumid: number,
  image: string,
}

export const getEncryptedLocalStorageData = () => {
  const encrypt = CryptoJS.AES.encrypt(JSON.stringify(localStorage), encryptKey).toString();
  return encrypt
}

export const importEncryptedLocalStorage = (gameString: string) => {
  var bytes = CryptoJS.AES.decrypt(gameString, encryptKey);
  var data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  Object.keys(data).forEach(function (k) {
    localStorage.setItem(k, JSON.parse(JSON.stringify(data[k])));
  });
}

export const saveStatsToLocalStorage = (gameStats: GameStats) => {
  localStorage.setItem(gameStatKey, JSON.stringify(gameStats))
}

export const loadStatsFromLocalStorage = () => {
  const encrypt = CryptoJS.AES.encrypt(JSON.stringify(localStorage), encryptKey).toString();
  const stats = localStorage.getItem(gameStatKey)
  return stats ? (JSON.parse(stats) as GameStats) : null
}

export const saveCardsToLocalStorage = (cards: WinningCard[]) => {
  localStorage.setItem(winningCardKey, JSON.stringify(cards))
}

export const loadCardsFromLocalStorage = () => {
  const cards = localStorage.getItem(winningCardKey)
  return cards ? JSON.parse(cards) as WinningCard[] : null
}

export const generateCardsSequence = () => {
  if (localStorage.getItem(cardsSequenceKey) == null) {
    const arr: number[] = [];
    for (let i = 1; i <= 126; i++) {
      arr.push(i)
    }
    shuffle(arr)
    localStorage.setItem(cardsSequenceKey, JSON.stringify(arr));
  } 
  if (!getCardsSequence()?.includes(127)) {
    const arrToInsert = [127, 128, 129, 130, 131, 132, 133]
    const cardSeq = getCardsSequence()
    for (var i = 0; i < arrToInsert.length; i++) {
      cardSeq?.splice(Math.floor(Math.random() * (cardSeq.length) + cardIndex + 1), 0, arrToInsert[i])
    }
    localStorage.setItem(cardsSequenceKey, JSON.stringify(cardSeq));
  }
}

export const getCardsSequence = () => {
  const cardSequence = localStorage.getItem(cardsSequenceKey)
  return cardSequence ? JSON.parse(cardSequence) as number[] : null
}

const shuffle = (array: number[]) => {
  let currentIndex = array.length, randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}